<template>
    <div>
        <div class="order-header">
            <i class="ion-map"></i>
            <h2>Planowana trasa</h2>
        </div>

        <div id="address-map">
        </div>

    </div>
</template>

<script>
    export default {
        name: 'addressMap',
        props: ['step', 'address', 'warehouse'],
        data () {
            return {
                map: null,
                directionsService: null,
                directionsRenderer: null,
                googleDistance: 0,
                divisionLocation: {},
                division: {},
                custLocation: {},
                urls: {
                    'outOfZone': '/api/delivery/test/outOfZone/'
                },
                custLocationMarker: null,
                deliveryRoute: null
            }
        },

        mounted: function() {
            var self = this;



            Event.$on('directionServiceResults', function(points) {
                console.log('MAMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM')
                 console.log(points.routes["0"])
                var pl = self.pathFromLeg(points.routes["0"].overview_polyline)
                console.log(pl)
                if (points) {
                    self.$store.commit('setDirectionServiceResults', true)
                }
                var decodedPoints =
google.maps.geometry.encoding.decodePath(points.routes["0"].overview_polyline) ;

var encodedPolyline = new google.maps.Polyline ( {
              strokeColor: "#970E04" ,
              strokeOpacity: 1.0 ,
              strokeWeight: 2 ,
              path: decodedPoints ,
              clickable: false
} );
encodedPolyline.setMap(self.map);
            })

            Event.$on('setDivision', function(custLocation) {
                console.log('setDivision - in adress map')
                if (custLocation) {
                    self.division = custLocation;
                    self.divisionLocation.Lat = custLocation.Lat
                    self.divisionLocation.Lng = custLocation.Lng
                }
            });

            self.directionsService = new google.maps.DirectionsService();
            self.directionsRenderer = new google.maps.DirectionsRenderer();
            self.directionsRenderer.setMap(self.map);

            Event.$on('mapSetCustomLocation', function(custLocation) {
                console.log('mapSetCustomLocation***************************mapSetCustomLocation');
                if (custLocation) {
                    if (self.custLocationMarker != null) {
                        self.custLocationMarker.setMap(null);
                        console.log('remove - marker');
                    }
                    self.addMarker(custLocation.Lat, custLocation.Lng, "Klient");
                    self.custLocation = custLocation;
                    self.map.panTo(new google.maps.LatLng(custLocation.Lat, custLocation.Lng));
                }
                // jest custom loc i wh
                self.getDirections();
            });
        },

        watch: {
            step: function(val, oldVal) {
                var self = this
                if (this.map === null) {this.initMap();}
                if (self.division.Lat) {
                    self.addMarker(self.division.Lat, self.division.Lng, "");
                    self.map.panTo(new google.maps.LatLng(self.division.Lat, self.division.Lng));
                }
            }
        },

        methods: {
            pathFromLeg: function (leg) {
                //if (!google) { return; }
                var segments = [];
                _.forEach(leg.steps, ({ polyline: { points } }) => {
                    const path = google.maps.geometry.encoding.decodePath(points);
                    _.forEach(path, segment => segments.push(segment));
                });
                return segments;
                },
            showRoute: function(directionResult) {
                alert('showRoute')
                if (this.deliveryRoute != null) {
                    this.deliveryRoute.setMap(null);
                }
                var myRoute = directionResult.routes[0].legs[0];
                var self = this;
                var linePath = [];

                for (var i = 0; i < myRoute.steps.length; i++) {
                    linePath.push( myRoute.steps[i].start_point);
                }
                linePath.push(new google.maps.LatLng(self.custLocation.Lat, self.custLocation.Lng))

                var lineOptions = {
                    path: linePath,
                    strokeWeight: 2,
                    strokeColor: '#FF0000',
                    strokeOpacity: 0.8
                }
                var polyline = new google.maps.Polyline(lineOptions);
                polyline.setMap(this.map);
                this.deliveryRoute = polyline;
            },

            addMarker: function (lat, lng, label) {
                var coordinate = new google.maps.LatLng(lat, lng);
                var marker = new google.maps.Marker({
                    position: coordinate,
                    mapTypeControl: false,
                    map: this.map,
                    title: '' + label
                });
                // If you don't specify a Map during the initialization //of the Marker you can add it later using the line //below
                marker.setMap(this.map);
                if (label === 'Klient') {
                    console.log('ADDING CUSTOM MARKER');
                    this.custLocationMarker = marker;
                }
            },

            drawLine: function (lineCoordinates, strokeCol) {
                console.log('DRAW LINIE IN ADDRES MAP')
                console.log(lineCoordinates)

                var pointCount = lineCoordinates.length;
                var linePath = [];
                for (var i = 0; i < pointCount; i++) {
                    if (i == 0) {
                        this.map.panTo(new google.maps.LatLng(lineCoordinates[i][1] , lineCoordinates[i][0]));
                    }
                    var tempLatLng = new google.maps.LatLng( lineCoordinates[i][1] , lineCoordinates[i][0]);
                    this.addMarker(lineCoordinates[i][1] , lineCoordinates[i][0])
                    linePath.push(tempLatLng);
                    console.log(lineCoordinates[i][1] , lineCoordinates[i][0])
                }
                var lineOptions = {
                    path: linePath,
                    strokeWeight: 2,
                    strokeColor: strokeCol,
                    strokeOpacity: 1
                }
                var polyline = new google.maps.Polyline(lineOptions);
                polyline.setMap(this.map);
            },

            initMap: function () {
                console.log('INIT MAP')
                google.maps.visualRefresh = true;
                var centerPoint = [52.229676,  21.012229];
                var zoomLevel = 10;
                this.map = new google.maps.Map(document.getElementById('address-map'), {
                    center: {lat: centerPoint[0], lng: centerPoint[1]},
                    //disableDefaultUI: false,
                    //scaleControl: true,
                    scrollwheel: false,
                    zoom: zoomLevel
                })
            },

            getWhString: function() {
                return this.warehouse.PostalCode + ' ' + this.warehouse.City + ' ' + this.warehouse.Street + ' ' + this.warehouse.StreetNo;
            },

            getCustAddressString: function() {
                return this.address.PostalCode + ' ' + this.address.City + ' ' + this.address.Street + ' ' + this.address.StreetNo;
            },

            getDirections: function () {
                console.log('getDirections******');
                var self = this;
                //define an array that will hold all the waypoints
                var waypnts = [];
                //define a directionsRequest object
                var directionRequest;

                var orig = new google.maps.LatLng(self.divisionLocation.Lat, self.divisionLocation.Lng);
                var dest = new google.maps.LatLng(self.custLocation.Lat, self.custLocation.Lng);

                orig = this.getWhString();
                dest = this.getCustAddressString();

                directionRequest = {
                    origin: orig,
                    destination: dest,
                    travelMode: google.maps.TravelMode.DRIVING,
                    avoidHighways: true,
                    avoidTolls: true

                };

                // send the request to the directionsService
                self.directionsService.route(directionRequest, function(result, status) {
                    console.log('directionsService - - - - - - - - ');
                    console.log(status);
                    if (status == google.maps.DirectionsStatus.OK) {
                        self.directionsRenderer.setDirections(result);
                        //self.showRoute(result);
                        console.log('SHOULD DRAW ROUTEE');
                        self.googleDistance = result.routes[0].legs[0].distance.text;
                        self.$emit('setDelivDistance', self.googleDistance);
                        return;
                        self.$http.post(self.urls.outOfZone, {divisionId: self.warehouse.ID, routePath: result.routes[0].overview_polyline }).then(function (response) {
                            if (response.data.lineCoords) {
                                //self.drawLine(response.data.lineCoords, '#000000');
                                var pointsCount = response.data.lineCoords.length;
                                self.addMarker(response.data.lineCoords[pointsCount - 1][1], response.data.lineCoords[pointsCount - 1][0], "Pkt końcowy strefy");
                                self.kmOutZone = response.data.kmOutZone;
                                console.log('USTAWIAM kmOutZone in AddressMap' + self.kmOutZone);
                                Event.$emit('kmOutZone', self.kmOutZone);
                            } else {
                                Event.$emit('kmDistance', self.googleDistance);
                            }
                        });
                    } else {
                        alert('Cannot find directions because: ' + status);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// AddressMap.vue?1e077590